export enum SCHEDULE_TYPES {
    SpecificDays = "specific_days",
    SpecificHours = "specific_hours"
}
